import { AgsExportHistory } from 'Components/Ags/Core/AgsExportHistory';
import AgsExportHeader from 'Components/Ags/Export/AgsExportHeader';
import AgsExportSection from 'Components/Ags/Export/AgsExportSection';
import FixedAgsExportHeader from 'Components/Ags/Export/Header/FixedAgsHeader';
import { Message, Spinner } from 'Components/Core';
import ErrorBoundary from 'Components/Core/ErrorBoundary';
import { PageSection } from 'Components/Layout';
import Page from 'Components/Pages/Core/Page';
import { actions } from 'Data/ReduxViewModels/Ags/Export';
import { actions as appActions } from 'Data/ReduxViewModels/App';
import { TitleSource } from 'Data/ReduxViewModels/App/types';
import { IAgsExportRevision } from 'Data/ViewModels/Ags';
import { hasNonEmptyValue, hasValue } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import './AgsExportPage.scss';

const AgsExportPage: React.FC = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const agsExportId: Guid = params.agsExportId!.toLowerCase();

  const agsPermission = useSelector((state) => state.user.data?.Claims && state.user.data?.Claims['sq.ags.export']);
  const ready = useSelector((state) => state.agsExport.status.ready);
  const tableData = useSelector(
    pipe(
      (state) => state.agsExport.agsExport,
      (agsExport) => agsExport?.Revisions ?? ({} as Array<IAgsExportRevision>)
    ),
    deepEquals
  );
  const agsExportLoaded = useSelector(
    pipe(
      (state) => state.agsExport.agsExport,
      (agsExport) => hasValue(agsExport)
    )
  );
  const identifier = useSelector((state) => state.agsExport.pageHeader.identifier);

  useEffect(() => {
    dispatch(actions.init(agsExportId));
  }, [dispatch, agsExportId]);

  const pageTitle =
    ready && agsExportLoaded ? [identifier, 'AGS Data'].filter(hasNonEmptyValue).join(' - ') : undefined;
  useEffect(() => {
    if (hasNonEmptyValue(pageTitle)) dispatch(appActions.setPageTitle({ pageTitle, source: TitleSource.Specific }));
    return () => {
      dispatch(appActions.setPageTitle({ pageTitle: undefined, source: TitleSource.Specific }));
    };
  }, [dispatch, pageTitle]);

  if (!ready) {
    return (
      <Page>
        <Spinner large />
      </Page>
    );
  } else if (!agsExportLoaded) {
    return (
      <Page>
        <PageSection>
          <Message error>AGS export not loaded</Message>
        </PageSection>
      </Page>
    );
  }
  return (
    <Page>
      <div className="AgsExportPage">
        <ErrorBoundary>
          <FixedAgsExportHeader />
          <div className="AgsExportPage-Content">
            <AgsExportHeader />
            {agsPermission && <AgsExportSection />}
            <AgsExportHistory
              colWidths={['0', '0', '10%', '23%', '13%', '44%', '10%']}
              minColWidths={['0', '0', '40px', '135px', '80px', '10px', '40px']}
              name="WorkOrder-ExportHistory"
              data={tableData}
              withDateRange={false}
            />
          </div>
        </ErrorBoundary>
      </div>
    </Page>
  );
};

export default AgsExportPage;
